export const TAGS = `tags`;
